module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0048354f2d2f5a137359716b07da6ddd.png";